import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = ["index", "text"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _normalizeProps(_guardReactiveProps(_ctx.$attrs)), [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highlights, (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (!item.isHighlighted)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(item.text), 1)
            ], 64))
          : (_openBlock(), _createElementBlock("mark", {
              class: "highlight",
              key: item.index,
              index: item.index,
              text: item.text
            }, _toDisplayString(item.text), 9, _hoisted_1))
      ], 64))
    }), 256))
  ], 16))
}